/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-08 10:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Card, Button, Heading } from '@shopify/polaris';

import * as dashboardActionV3 from 'actions/dashboard-v3-actions';
import * as optionEmailAction from 'actions/dashboard/option-email-action';
import withBlockCanDismiss from './blockCanDismiss';
import { APP_LANGUAGE_ENGLISH_VALUE } from 'src/constants/language-setting';

import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { isEmailOpt, isExceedLength } from 'src/helpers/form-validation-helper';
import { RenderTextField } from 'src/components/views/common/forms/render-textfield';
import optionInEmailImg from 'src/assets/images/dashboard-v3/option-email.png';

const isEmailOptValue = isEmailOpt();
const isExceedLengthValue = isExceedLength(50);

type ComposedProps = Props & WithI18nProps;
class OptionEmail extends Component<ComposedProps> {
  render() {
    const { i18n, handleSubmit, loading, pristine, appLanguage } = this.props;
    return (
      <div className="BC-OptionInEmail__DashboardV3">
        <Card sectioned>
          <div className="option-email-content">
            <Heading>{i18n.translate(`AdminHTML.DashboardV3.OptionInEmail.title`)}</Heading>
            <p>{i18n.translate(`AdminHTML.DashboardV3.OptionInEmail.content`)}</p>
            <div className="option-input" style={{ alignItems: 'flex-start' }}>
              <Field
                name="optEmail"
                component={RenderTextField}
                placeholder={i18n.translate('AdminHTML.DashboardV3.OptionInEmail.placeholderField')}
                validate={[isEmailOptValue, isExceedLengthValue]}
              />
              <Button
                loading={loading && !pristine}
                onClick={handleSubmit(this.handleSubmit.bind(this))}>
                {i18n.translate('AdminHTML.DashboardV3.OptionInEmail.actionLabel')}
              </Button>
            </div>
          </div>
          <div
            className="background-image"
            style={{ width: `${appLanguage === 'en' ? '51%' : '57%'}` }}>
            <img src={optionInEmailImg} alt="option-in-email" />
          </div>
        </Card>
      </div>
    );
  }
  // Handle default form submit
  handleDefaultSubmit(e) {
    e.preventDefault();
  }

  //Handle submit
  handleSubmit = async data => {
    const { addOptionEmail, dismissDashboardBlock } = this.props;
    if (data.optEmail) {
      const result = await addOptionEmail(data);
      if (result.type === 'ADD_OPTION_EMAIL_SUCCESS') {
        dismissDashboardBlock('optionInEmail');
      }
    }
  };
}

const mapStateToProps = (state, props) => {
  return {
    appLanguage: _.get(state.oauth.tenantApp, 'appLanguage', APP_LANGUAGE_ENGLISH_VALUE),
    loading: state.optionEmail.loading,
    success: state.optionEmail.success,
    error: state.optionEmail.error
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  addOptionEmail: (body: Object) => dispatch(optionEmailAction.addOptionEmail(body, ownProps.i18n)),
  dismissDashboardBlock: (blockName: string) =>
    dispatch(dashboardActionV3.processDismissBlock(blockName, ownProps.i18n))
});

const OptionEmailForm = reduxForm({
  form: 'OptionInEmail', // a unique identifier for this form
  enableReinitialize: true
})(OptionEmail);

export default withBlockCanDismiss(
  withI18n()(connect(mapStateToProps, mapDispatchToProps)(OptionEmailForm))
);
